<template>
  <section id="festival">
    <h1>Festival</h1>
    <p class="aha-info" v-html="info.text">
    </p>
  </section>
</template>

<script>
export default {
  name: 'info',
  computed: {
    info () {
      return this.$store.getters.getPageByUID('festival')
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

#festival {
  border-bottom:0 !important;
  margin-bottom: 0 !important;
  .aha-info {
    margin-bottom: $gap * 5;
    padding-bottom: $gap / 2;
    border-bottom: 2px solid $font-color;
    @media only screen and (max-width:$phone) {
      border-bottom: 1px solid $font-color;
    }
  }
}

</style>
